var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "17.368",
        viewBox: "0 0 17.368 17.368",
        width: "17.368",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "g",
        {
          attrs: {
            id: "Group_2634",
            "data-name": "Group 2634",
            transform: "translate(-1774.665 -253.802)",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Icon_ionic-md-remove-circle-outline",
                "data-name": "Icon ionic-md-remove-circle-outline",
                transform: "translate(1771.29 250.427)",
              },
            },
            [
              _c("path", {
                attrs: {
                  id: "Path_2197",
                  d: "M12.059,5.129a6.928,6.928,0,1,1-4.9,2.029,6.9,6.9,0,0,1,4.9-2.029m0-1.754a8.684,8.684,0,1,0,8.684,8.684,8.683,8.683,0,0,0-8.684-8.684Z",
                  "data-name": "Path 2197",
                  fill: "#ffa800",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_2198",
                  d: "M19.411,18.277H10.477V16.523h8.935Z",
                  "data-name": "Path 2198",
                  fill: "#ffa800",
                  transform: "translate(-2.885 -5.341)",
                },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }